<template>
  <v-container>
    <div style="height: 20px"></div>
    <v-row justify="center" class="mb-10" v-if="postInfo != null">
      <!-- TODO: AQUI VA EL MENU  DE EDICION -->
      <v-btn-toggle v-model="editButtons">
        <v-btn @click="editarArticulo()" v-if="isJunior == false">
          <v-icon class="mr-2" color="primary">mdi-pencil</v-icon>
          Editar Artículo
        </v-btn>
        <v-btn v-if="postInfo.baestatus != 1" @click="cambiarEstatusArticulo(1)">
          <v-icon class="mr-2" color="green">mdi-auto-upload</v-icon>
          Publicar Artículo 
        </v-btn>
        <v-btn v-if="postInfo.baestatus != 0" @click="cambiarEstatusArticulo(0)">
          <v-icon class="mr-2" color="red">mdi-arrow-down-bold-circle</v-icon>
          Desactivar Artículo
        </v-btn>
        <v-btn @click="cambiarEstatusArticulo(4)">
          <v-icon class="mr-2" color="red">mdi-archive</v-icon>
          Archivar Artículo
        </v-btn>
      </v-btn-toggle>
    </v-row>
    <v-row v-if="postInfo != null" justify="center">
      <v-col cols="11" md="7" lg="6" class="test-area">
        <v-row justify="center">
          <v-col cols="12">
            <h1 class="post-title">{{ postInfo.batitulo }}</h1>
          </v-col>
          <v-col cols="12">
            <div style="display: flex; flex-direction: row">
              <div style="width: 70px">
                <img class="blog-autor-container-style"
                  v-bind:src="'https://www.ausa.com.mx/img/ausa_logo_vector_v3.png'" alt="logo_ausa" />
              </div>

              <div class="blog-title-container">
                <p class="autor-text-style">{{ postInfo.uslogin }}</p>
                <p class="fecha-text-style">
                  {{ postInfo.bafhpublicacion }}
                  <v-icon size="20" class="ml-1"> mdi-eye </v-icon>
                  <strong> {{ postInfo.balecturas }} </strong>
                </p>
              </div>

              <div class="mt-5">
                <div style="display: flex" v-if="postInfo.TieneLike == 0">
                  <v-btn text style="margin-left: auto" @click="clickOnLike()">
                    <v-icon size="16" style="margin-right: 5px">mdi-thumb-up</v-icon>
                    Me Gusta
                  </v-btn>
                  <div style="float: right">
                    <v-avatar color="primary" size="35" tile>
                      <span style="color: #ffffff">{{
                        postInfo.CantidadLikes
                      }}</span>
                    </v-avatar>
                  </div>
                </div>

                <div style="display: flex" v-if="postInfo.TieneLike == 1">
                  <v-btn text style="margin-left: auto" color="primary" @click="clickOnDislike()">
                    <v-icon size="16" style="margin-right: 5px">mdi-thumb-up</v-icon>
                    Me Gusta
                  </v-btn>
                  <div style="float: right">
                    <v-avatar color="primary" size="35" tile>
                      <span style="color: #ffffff">{{
                        postInfo.CantidadLikes
                      }}</span>
                    </v-avatar>
                  </div>
                </div>
              </div>
            </div>
          </v-col>

          <v-col cols="12" class="my-1">

            <div class="thumbnail">
              <div v-if="postInfo.baEnAmazonS3 == 1">
                <img v-bind:src="postInfo.baimagen" :alt="postInfo.badesc" class="image-rounded-style" />
              </div>
              <div v-else>
                <img v-bind:src="dynamicRoute + postInfo.baimagen" :alt="postInfo.badesc" class="image-rounded-style" />
              </div>
            </div>
          </v-col>

          <v-col cols="12" class="mt-1">
            <div class="editor-just-read">
              <vue-editor disabled v-model="htmlContent"></vue-editor>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import BlogService from "@/services/Blogs/Blogs.service.js";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import { VueEditor, Quill } from "vue2-editor";

export default {
  title() {
    return this.$route.meta.title
  },
  components: { VueEditor, },
  props: ['currentBlogData', 'isJunior'],
  data() {
    return {
      tokenInfo: [],
      postInfo: null,
      htmlContent: " ",

      editButtons: null,
      dynamicRoute: ""
    };
  },
  computed: {
    ...mapState(["domain", "informationPage"]),
  },
  async mounted() {
    this.dynamicRoute = this.domain.domainNameDev;
    if (this.currentBlogData != null) {
      await this.getTokenData();
      this.getInitialItems();
    }
  },

  methods: {
    async getTokenData() {
      let tokenData = this.currentBlogData;
      let getTokenData = MetodosGenerales.getJsonTokenData(tokenData);
      this.tokenInfo = getTokenData;
    },
    async getInitialItems() {
      let reponse = await BlogService.ObtenerPostInfo(this.tokenInfo.baclave);
      this.postInfo = reponse[0];
      this.htmlContent = this.postInfo.bacontenido;

    },

    async clickOnLike() {
      this.postInfo.TieneLike = 1;
      this.postInfo.CantidadLikes = this.postInfo.CantidadLikes + 1;
      let response = await BlogService.LikeBlogPost(this.postInfo.baclave);
    },

    async clickOnDislike() {
      this.postInfo.TieneLike = 0;
      this.postInfo.CantidadLikes = this.postInfo.CantidadLikes - 1;
      let response = await BlogService.LikeBlogPost(this.postInfo.baclave);
    },

    async editarArticulo() {
      this.$emit('edit-art', this.postInfo);
    },

    async cambiarEstatusArticulo(status) {
      this.$swal({
        title: "Guardando, espere un momento...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        }
      });
      let response = await BlogService.CambiarEstatusArticulo(this.postInfo.baclave, status)
      if (response == true) {
        this.$swal({
          position: "center",
          icon: "success",
          title: "Correcto",
          text: "Se han guardado los cambios",
          showConfirmButton: true,
          timer: 5000,
        }).then(() => {
          this.$emit('reset-main');
        });

      } else {
        this.$swal({
          position: "center",
          icon: "error",
          title: "Oops...",
          text: "Ha ocurrido un error inesperado intente nuevamente más tarde",
          showConfirmButton: true,
          timer: 5000,
        });
      }
    },
  },
};
</script>

<style>
.editor-just-read .ql-toolbar {
  border: none !important;
  display: none !important;
}

.editor-just-read .ql-clipboard {
  border: none !important;
  display: none !important;
}

.editor-just-read .ql-tooltip {
  border: none !important;
  display: none !important;
}

.editor-just-read .ql-container {
  border: none !important;
}
</style>

<style scoped>
.image-rounded-style {
  border-radius: 14px;
}

.blog-autor-container-style {
  width: 65px;
  border-radius: 50%;
}

.blog-title-container {
  width: 90%;
  padding: 2px 2px 2px 10px;
}

.post-title {
  font-family: "Montserrat", sans-serif;
  font-weight: 800;
  font-style: normal;
  line-height: 1.2;
  color: #2285bb;
  font-size: 34px;
  margin-bottom: 1px;
}

.fecha-text-style {
  font-family: "Poppins", sans-serif;
  font-size: 13px;
  font-weight: 200;
  color: grey;
  margin-bottom: 0px;
}

.autor-text-style {
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 2px;
}
</style>
